<router-outlet></router-outlet>
<app-booking-modal></app-booking-modal>

<!-- WhatsApp Floating Button -->
<a 
  [href]="whatsappLink" 
  target="_blank" 
  rel="noopener noreferrer"
  class="whatsapp-float"
  aria-label="Chat with us on WhatsApp"
  title="Chat with us on WhatsApp">
  <i class="bi bi-whatsapp"></i>
</a>

<!-- Back to Top Button -->
<button 
  *ngIf="showBackToTop"
  (click)="scrollToTop()"
  class="back-to-top"
  aria-label="Back to top"
  title="Back to top">
  <i class="bi bi-chevron-up"></i>
</button>
